// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { BranchListDto, NboBranchList } from "../../api/backend-openapi";
import { setBranchList } from "./BranchesEvents";

export const BranchesStore = createStore<BranchListDto>({}).on<NboBranchList>(
  setBranchList,
  (_state: BranchListDto, payload: NboBranchList) => payload?.branches || {}
);
